"use client";

import React from "react";
import { AppBar, Toolbar, Container, Box, Button } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import Link from "next/link";

import Logo from "@/src/common/components/Logo";

const Header: React.FC = () => {
  const { mode, systemMode } = useColorScheme();
  const isDarkMode =
    mode === "dark" || (mode === "system" && systemMode === "dark");

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: isDarkMode
          ? "rgba(20, 25, 35, 0.95)"
          : "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        boxShadow: isDarkMode
          ? "0 2px 20px rgba(0, 0, 0, 0.3)"
          : "0 2px 20px rgba(0, 0, 0, 0.1)",
        color: isDarkMode ? "#ffffff" : "text.primary",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          sx={{ justifyContent: "space-between", py: 2, minHeight: "80px" }}
        >
          <Link href="/" passHref style={{ textDecoration: "none" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                textDecoration: "none",
              }}
            >
              <Logo height={52} width={220} />
            </Box>
          </Link>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Link href="/signIn" passHref style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  mt: 2,
                  py: 1.5,
                  px: 3,
                  borderColor: "#42A6F6",
                  color: "#42A6F6",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#42A6F6",
                    color: "white",
                    borderColor: "#42A6F6",
                  },
                  ...(isDarkMode && {
                    borderColor: "#42A6F6",
                    color: "#42A6F6",
                    backgroundColor: "rgba(66, 166, 246, 0.1)",
                    "&:hover": {
                      backgroundColor: "#42A6F6",
                      color: "#1a1a1a",
                      borderColor: "#42A6F6",
                    },
                  }),
                }}
              >
                Sign in
              </Button>
            </Link>
            <Link href="/signUp" passHref style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  mt: 2,
                  py: 1.5,
                  px: 3,
                  backgroundColor: "#42A6F6",
                  color: "white",
                  borderColor: "#42A6F6",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#7BC3F8",
                    color: "white",
                    borderColor: "#42A6F6",
                  },
                  ...(isDarkMode && {
                    backgroundColor: "#42A6F6",
                    color: "#F7A56F",
                    borderColor: "#42A6F6",
                    fontWeight: 700,
                    "&:hover": {
                      backgroundColor: "#F49045",
                      color: "#1a1a1a",
                      borderColor: "#F49045",
                    },
                  }),
                }}
              >
                Sign up
              </Button>
            </Link>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
